module.exports = __webpack_public_path__ + "static/media/vip-room.6dc64f5c.png";